import { FC } from 'react';

import { BillOfLadingResponse } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Paper } from '@ravago/shared/radiance/components/paper/components/Paper/Paper';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { BolDocumentContent } from './bol-document-content';

interface Props {
   billsOfLading: BillOfLadingResponse[];
   onRequestBol: (bol: BillOfLadingResponse) => void;
}

export const BillOfLadingDocuments: FC<Props> = ({ billsOfLading, onRequestBol }: Props) => {
   const translate = useTranslations();

   return (
      <Box direction="column" gap="sm">
         {billsOfLading.length > 0 ? (
            <>
               {billsOfLading.map((bolDoc, index) => (
                  // eslint-disable-next-line @eslint-react/no-array-index-key
                  <Paper direction="row" key={`doc-${index}`} width="100%">
                     <Box justify="between" items="start" width="100%" direction="row">
                        <BolDocumentContent data={bolDoc} onRequestBol={onRequestBol} />
                     </Box>
                  </Paper>
               ))}
            </>
         ) : (
            <Typography variant="body" component="span">
               {translate('shipment.documents.no-documents-available')}
            </Typography>
         )}
      </Box>
   );
};
